// src/panels/LoginModal.jsx
import React, { useEffect, useRef, useState } from "react";
import bg from "../assets/brand/LOGIN_BG_PIC_V1.png";

export default function LoginModal({ open, onClose }) {
  const [box, setBox] = useState(null); // {left, top, width, height, radius}
  const roRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const target = document.querySelector(".main-map-container");
    if (!target) return;

    const computeBox = () => {
      const r = target.getBoundingClientRect();
      const cs = window.getComputedStyle(target);

      // Borderbreiten ermitteln und abziehen
      const bl = parseFloat(cs.borderLeftWidth)   || 0;
      const br = parseFloat(cs.borderRightWidth)  || 0;
      const bt = parseFloat(cs.borderTopWidth)    || 0;
      const bb = parseFloat(cs.borderBottomWidth) || 0;

      // Border-Radius (vereinfachend: obere linke Ecke)
      const radius = cs.borderTopLeftRadius || "0px";

      setBox({
        left: r.left + bl,
        top:  r.top  + bt,
        width:  Math.max(0, r.width  - bl - br),
        height: Math.max(0, r.height - bt - bb),
        radius,
      });
    };

    // Initial + Listener
    computeBox();
    const onScroll = () => computeBox();
    const onResize = () => computeBox();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize);

    // Reagiert auf Größenänderungen des Targets (auch bei UI-Scale/Transform)
    roRef.current = new ResizeObserver(computeBox);
    roRef.current.observe(target);

    // Fallback für Layout-Ticks
    const raf = requestAnimationFrame(computeBox);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
      if (roRef.current) {
        try { roRef.current.disconnect(); } catch {}
        roRef.current = null;
      }
    };
  }, [open]);

  if (!open || !box) return null;

  return (
    <>
      {/* Dimmer – deckt nur die Mapfläche ab */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          left: box.left,
          top: box.top,
          width: box.width,
          height: box.height,
          borderRadius: box.radius,
          background: "rgba(0,0,0,.35)",
          zIndex: 1000,
        }}
        aria-hidden
      />

      {/* Inhalt exakt in Map-Koordinaten */}
      <div
        role="dialog"
        aria-modal="true"
        style={{
          position: "fixed",
          left: box.left,
          top: box.top,
          width: box.width,
          height: box.height,
          borderRadius: box.radius,
          overflow: "hidden",
          zIndex: 1001,
          boxSizing: "border-box",
        }}
      >
        {/* Hintergrundbild füllt exakt den Bereich, ohne überzustehen */}
        <img
          src={bg}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            userSelect: "none",
            pointerEvents: "none",
          }}
          draggable="false"
        />

        {/* Deine Login-UI oben drauf (Platzhalter) */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "grid",
            placeItems: "center",
            padding: 20,
          }}
        >
          <div
            style={{
              width: 340,
              maxWidth: "90%",
              borderRadius: 12,
              background: "rgba(10,12,18,.75)",
              border: "1px solid rgba(28,46,73,.86)",
              boxShadow: "0 12px 28px rgba(0,0,0,.45)",
              padding: 16,
              color: "#e6edf3",
            }}
          >
            <div style={{ fontWeight: 700, marginBottom: 8, letterSpacing: ".02em" }}>
              Anmelden
            </div>
            <div style={{ display: "grid", gap: 10 }}>
              <input
                type="text"
                placeholder="E-Mail / Name"
                style={fieldStyle}
              />
              <input
                type="password"
                placeholder="Passwort"
                style={fieldStyle}
              />
              <button
                style={{
                  borderRadius: 10,
                  border: "1px solid rgba(255,255,255,.14)",
                  background: "linear-gradient(180deg, rgba(255,255,255,.08), rgba(0,0,0,.2))",
                  color: "#e6edf3",
                  padding: "8px 10px",
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                Login
              </button>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12 }}>
                <a href="#" style={{ color: "#9CB0E6", textDecoration: "none" }}>Konto erstellen</a>
                <a href="#" style={{ color: "#9CB0E6", textDecoration: "none" }}>Passwort vergessen</a>
              </div>
            </div>
          </div>
        </div>

        {/* Schließen (X) */}
        <button
          onClick={onClose}
          aria-label="Schließen"
          title="Schließen"
          style={{
            position: "absolute",
            top: 10,
            right: 12,
            width: 28,
            height: 28,
            borderRadius: 8,
            border: "1px solid rgba(255,255,255,.18)",
            background: "rgba(0,0,0,.35)",
            color: "#e6edf3",
            display: "grid",
            placeItems: "center",
            cursor: "pointer",
          }}
        >
          ×
        </button>
      </div>
    </>
  );
}

const fieldStyle = {
  borderRadius: 8,
  border: "1px solid rgba(255,255,255,.12)",
  background: "rgba(0,0,0,.25)",
  color: "#e6edf3",
  padding: "8px 10px",
  fontSize: 14,
  outline: "none",
  width: "100%",
};
